import store from '__common/store';
import {
  getExposureRibbonPoints,
  removeRubberBand,
} from '__editor/panelsEditor/components/rubberBand/rubberBand';
import {
  clearRubberBandPreview,
  isRubberBandPreviewActive,
  scheduleShadowSpriteSync,
  setHiddenPanelsOnStage,
  updateRubberBandOutline,
} from '__editor/panelsEditor/components/rubberBand/rubberBandPreview';
import { PanelsContainer } from '__editor/panelsEditor/models/panelsContainer';
import { markStageDirty } from '__editor/panelsEditor/components/stage/stageDirty';

export const drawRubberBandOnStage = (stage: PIXI.Container, panelsContainer: PanelsContainer, _prevRubberBandState) => {
  if (!stage || !panelsContainer) {
    return;
  }

  // Local drag preview already owns the overlay. A late React update from
  // START (empty Redux points) must not wipe sprites mid-drag.
  if (isRubberBandPreviewActive()) {
    return;
  }

  const { points, panelsShadow, panelsToRemove, mode } = store.getState().rubberBand;
  stage.children = removeRubberBand(stage.children);
  panelsContainer.children.map((panel) => { panel.visible = true; });

  if (!points.length) {
    clearRubberBandPreview(stage, panelsContainer);
    markStageDirty();
    return;
  }

  const ribbonPoints = mode === 'exposure' ? getExposureRibbonPoints(points) : points;
  updateRubberBandOutline(stage, ribbonPoints);

  if (mode === 'remove') {
    setHiddenPanelsOnStage(panelsToRemove);
  }

  if (panelsShadow && panelsShadow.length) {
    scheduleShadowSpriteSync(stage, panelsShadow);
  }

  markStageDirty();
};
